import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "h1" }, "Update Profile", -1)
const _hoisted_2 = {
  class: "container col-sm-6",
  style: {"float":"none"}
}
const _hoisted_3 = { class: "row col-12 border border-1 m-2 pt-2 pb-2" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "col-12 fw-bold h4 mb-2" }, "Personal Information")
], -1)
const _hoisted_6 = { class: "row col-12 text-left" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " First Name ", -1)
const _hoisted_8 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_9 = { class: "row col-12 text-left" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " Last Name ", -1)
const _hoisted_11 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_12 = { class: "row col-12 text-left" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " Previously Known As", -1)
const _hoisted_14 = { class: "row col-12 border border-1 m-2 pt-2 pb-2" }
const _hoisted_15 = { class: "container" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "h4 mb-2 fw-bold" }, "Work Information")
], -1)
const _hoisted_17 = { class: "row col-12 text-left" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " SIA No. ", -1)
const _hoisted_19 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_20 = { class: "row col-12 text-left" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " SIA Exp. Date ", -1)
const _hoisted_22 = { class: "col-4" }
const _hoisted_23 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_24 = { class: "row col-12 text-left" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " NI/UTR ", -1)
const _hoisted_26 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_27 = { class: "row col-12 text-left" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " PayRate ", -1)
const _hoisted_29 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_30 = { class: "row col-12 border border-1 m-2" }
const _hoisted_31 = { class: "container" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "h4 mb-2 fw-bold" }, "Contant Information")
], -1)
const _hoisted_33 = { class: "row col-12 text-left" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " Mobile ", -1)
const _hoisted_35 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_36 = { class: "row col-12 text-left" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " Email ", -1)
const _hoisted_38 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_39 = { class: "row col-12 text-left" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " Phone2 ", -1)
const _hoisted_41 = { class: "row col-12 border border-1 m-2 pt-2 pb-2" }
const _hoisted_42 = { class: "container" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "mb-2 fw-bold h4" }, "Address Information")
], -1)
const _hoisted_44 = { class: "row col-12 text-left" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " House Name/Number", -1)
const _hoisted_46 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_47 = { class: "row col-12 text-left" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " Street", -1)
const _hoisted_49 = { class: "row col-12 text-left" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " City ", -1)
const _hoisted_51 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_52 = { class: "row col-12 text-left" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " County ", -1)
const _hoisted_54 = { class: "row col-12 text-left" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " PostCode ", -1)
const _hoisted_56 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_57 = { class: "row col-12 text-left" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " Country ", -1)
const _hoisted_59 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_60 = { class: "row col-12 text-left" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " Conveyance ", -1)
const _hoisted_62 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_63 = { class: "row col-12 text-left" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " Emergency Contact", -1)
const _hoisted_65 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_66 = { class: "row col-12 border border-1 m-2 pt-2 pb-2" }
const _hoisted_67 = { class: "container" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "mb-2 fw-bold h4" }, "Origin Information")
], -1)
const _hoisted_69 = { class: "row col-12 text-left" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " DateOfBirth ", -1)
const _hoisted_71 = { class: "border border-1 col-8" }
const _hoisted_72 = { class: "col-6" }
const _hoisted_73 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_74 = { class: "row col-12 text-left" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " Country Of Birth ", -1)
const _hoisted_76 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_77 = { class: "row col-12 text-left" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " Nationality", -1)
const _hoisted_79 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_80 = { class: "row col-12 text-left" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " Gender", -1)
const _hoisted_82 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_83 = { class: "row col-12 text-left" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " Place Of Birth ", -1)
const _hoisted_85 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_86 = { class: "row col-12 border border-1 m-2 pt-2 pb-2" }
const _hoisted_87 = { class: "container" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "mb-2 fw-bold h4" }, "Identity Document Information")
], -1)
const _hoisted_89 = { class: "row col-12 text-left" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " ID Document", -1)
const _hoisted_91 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_92 = { class: "row col-12 text-left" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " Number ", -1)
const _hoisted_94 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_95 = { class: "row col-12 text-left" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " Issue Date ", -1)
const _hoisted_97 = { class: "border border-1 col-8" }
const _hoisted_98 = { class: "col-6" }
const _hoisted_99 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_100 = { class: "row col-12 text-left" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " Expiry Date ", -1)
const _hoisted_102 = { class: "border border-1 col-8" }
const _hoisted_103 = { class: "col-6" }
const _hoisted_104 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_105 = { class: "row col-12 text-left" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, " Issued By ", -1)
const _hoisted_107 = {
  key: 0,
  class: "col-1 text-danger fs-1"
}
const _hoisted_108 = /*#__PURE__*/_createElementVNode("span", { class: "col-10" }, [
  /*#__PURE__*/_createTextVNode(" By Submitting this form you agree to our "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://eaglesecurityltd.co.uk/privacy-policy-2",
    target: "blank"
  }, "Privacy Policy")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.securityOfficerObject.FirstName) = $event))
            }, null, 512), [
              [_vModelText, $setup.securityOfficerObject.FirstName]
            ]),
            (!$setup.securityOfficerObject.FirstName)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.securityOfficerObject.LastName) = $event))
            }, null, 512), [
              [_vModelText, $setup.securityOfficerObject.LastName]
            ]),
            (!$setup.securityOfficerObject.LastName)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.securityOfficerObject.PreviouslyKnownAs) = $event))
            }, null, 512), [
              [_vModelText, $setup.securityOfficerObject.PreviouslyKnownAs]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.securityOfficerObject.SiabadageNumber) = $event))
            }, null, 512), [
              [_vModelText, $setup.securityOfficerObject.SiabadageNumber]
            ]),
            (!$setup.securityOfficerObject.SiabadageNumber)
              ? (_openBlock(), _createElementBlock("span", _hoisted_19, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("span", _hoisted_22, " (" + _toDisplayString($setup.dateToYYYYMMDD($setup.securityOfficerObject.SiaExpiryDate)) + ")", 1),
            _withDirectives(_createElementVNode("input", {
              class: "col-4",
              type: "date",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.securityOfficerObject.SiaExpiryDate) = $event))
            }, null, 512), [
              [_vModelText, $setup.securityOfficerObject.SiaExpiryDate]
            ]),
            (!$setup.securityOfficerObject.SiaExpiryDate)
              ? (_openBlock(), _createElementBlock("span", _hoisted_23, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.securityOfficerObject.Ninumber) = $event))
            }, null, 512), [
              [_vModelText, $setup.securityOfficerObject.Ninumber]
            ]),
            (!$setup.securityOfficerObject.Ninumber)
              ? (_openBlock(), _createElementBlock("span", _hoisted_26, "*"))
              : _createCommentVNode("", true)
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "string",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.securityOfficerObject.PayRate) = $event))
            }, null, 512), [
              [_vModelText, $setup.securityOfficerObject.PayRate]
            ]),
            (!$setup.securityOfficerObject.FirstName)
              ? (_openBlock(), _createElementBlock("span", _hoisted_29, "*"))
              : _createCommentVNode("", true)
          ], 512), [
            [_vShow, false]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _hoisted_32,
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.securityOfficerObject.MobileNumber) = $event))
            }, null, 512), [
              [_vModelText, $setup.securityOfficerObject.MobileNumber]
            ]),
            (!$setup.securityOfficerObject.MobileNumber)
              ? (_openBlock(), _createElementBlock("span", _hoisted_35, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_36, [
            _hoisted_37,
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.securityOfficerObject.Email) = $event))
            }, null, 512), [
              [_vModelText, $setup.securityOfficerObject.Email]
            ]),
            (!$setup.securityOfficerObject.Email)
              ? (_openBlock(), _createElementBlock("span", _hoisted_38, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_39, [
            _hoisted_40,
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.securityOfficerObject.Phone2) = $event))
            }, null, 512), [
              [_vModelText, $setup.securityOfficerObject.Phone2]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("div", _hoisted_42, [
          _hoisted_43,
          _createElementVNode("div", _hoisted_44, [
            _hoisted_45,
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.securityOfficerObject.HouseNameNumber) = $event))
            }, null, 512), [
              [_vModelText, $setup.securityOfficerObject.HouseNameNumber]
            ]),
            (!$setup.securityOfficerObject.HouseNameNumber)
              ? (_openBlock(), _createElementBlock("span", _hoisted_46, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_47, [
            _hoisted_48,
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.securityOfficerObject.StreetAdress) = $event))
            }, null, 512), [
              [_vModelText, $setup.securityOfficerObject.StreetAdress]
            ])
          ]),
          _createElementVNode("div", _hoisted_49, [
            _hoisted_50,
            _withDirectives(_createElementVNode("select", {
              class: "col-8",
              id: "selectedCity",
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.selectedCityName) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cityList, (city) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: city.cityId
                }, _toDisplayString(city.name), 1))
              }), 128))
            ], 512), [
              [_vModelSelect, $setup.selectedCityName]
            ]),
            (!$setup.selectedCityName)
              ? (_openBlock(), _createElementBlock("span", _hoisted_51, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_52, [
            _hoisted_53,
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.securityOfficerObject.County) = $event))
            }, null, 512), [
              [_vModelText, $setup.securityOfficerObject.County]
            ])
          ]),
          _createElementVNode("div", _hoisted_54, [
            _hoisted_55,
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.securityOfficerObject.PostCode) = $event))
            }, null, 512), [
              [_vModelText, $setup.securityOfficerObject.PostCode]
            ]),
            (!$setup.securityOfficerObject.PostCode)
              ? (_openBlock(), _createElementBlock("span", _hoisted_56, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_57, [
            _hoisted_58,
            _withDirectives(_createElementVNode("select", {
              class: "col-8",
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.selectedAddressCountry) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.nationalityList, (n) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: n.id
                }, _toDisplayString(n.name), 1))
              }), 128))
            ], 512), [
              [_vModelSelect, $setup.selectedAddressCountry]
            ]),
            (!$setup.selectedAddressCountry)
              ? (_openBlock(), _createElementBlock("span", _hoisted_59, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_60, [
            _hoisted_61,
            _withDirectives(_createElementVNode("select", {
              class: "col-8",
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.selectedConveyanceName) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.conveyanceListArray, (conveyance) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: conveyance.id
                }, _toDisplayString(conveyance.name), 1))
              }), 128))
            ], 512), [
              [_vModelSelect, $setup.selectedConveyanceName]
            ]),
            (!$setup.selectedConveyanceName)
              ? (_openBlock(), _createElementBlock("span", _hoisted_62, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_63, [
            _hoisted_64,
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.securityOfficerObject.NextOfKin) = $event))
            }, null, 512), [
              [_vModelText, $setup.securityOfficerObject.NextOfKin]
            ]),
            (!$setup.securityOfficerObject.NextOfKin)
              ? (_openBlock(), _createElementBlock("span", _hoisted_65, "*"))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_66, [
        _createElementVNode("div", _hoisted_67, [
          _hoisted_68,
          _createElementVNode("div", _hoisted_69, [
            _hoisted_70,
            _createElementVNode("span", _hoisted_71, [
              _createElementVNode("span", _hoisted_72, "(" + _toDisplayString($setup.dateToYYYYMMDD($setup.securityOfficerObject.DateOfBirth)) + ") ", 1),
              _withDirectives(_createElementVNode("input", {
                class: "col-6",
                type: "date",
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.securityOfficerObject.DateOfBirth) = $event))
              }, null, 512), [
                [_vModelText, $setup.securityOfficerObject.DateOfBirth]
              ])
            ]),
            (!$setup.securityOfficerObject.DateOfBirth)
              ? (_openBlock(), _createElementBlock("span", _hoisted_73, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_74, [
            _hoisted_75,
            _withDirectives(_createElementVNode("select", {
              class: "col-8",
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (($setup.selectedCountryOfBirth) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.nationalityList, (n) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: n.id
                }, _toDisplayString(n.name), 1))
              }), 128))
            ], 512), [
              [_vModelSelect, $setup.selectedCountryOfBirth]
            ]),
            (!$setup.selectedCountryOfBirth)
              ? (_openBlock(), _createElementBlock("span", _hoisted_76, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_77, [
            _hoisted_78,
            _withDirectives(_createElementVNode("select", {
              class: "col-8",
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.selectedNationality) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.nationalityList, (n) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: n.id
                }, _toDisplayString(n.name), 1))
              }), 128))
            ], 512), [
              [_vModelSelect, $setup.selectedNationality]
            ]),
            (!$setup.selectedNationality)
              ? (_openBlock(), _createElementBlock("span", _hoisted_79, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_80, [
            _hoisted_81,
            _withDirectives(_createElementVNode("select", {
              class: "col-8",
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (($setup.selectedGenderType) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.genderList, (g) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: g.id
                }, _toDisplayString(g.name), 1))
              }), 128))
            ], 512), [
              [_vModelSelect, $setup.selectedGenderType]
            ]),
            (!$setup.selectedGenderType)
              ? (_openBlock(), _createElementBlock("span", _hoisted_82, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_83, [
            _hoisted_84,
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (($setup.securityOfficerObject.PlaceOfBirth) = $event))
            }, null, 512), [
              [_vModelText, $setup.securityOfficerObject.PlaceOfBirth]
            ]),
            (!$setup.securityOfficerObject.PlaceOfBirth)
              ? (_openBlock(), _createElementBlock("span", _hoisted_85, "*"))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_86, [
        _createElementVNode("div", _hoisted_87, [
          _hoisted_88,
          _createElementVNode("div", _hoisted_89, [
            _hoisted_90,
            _withDirectives(_createElementVNode("select", {
              class: "col-8",
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (($setup.selectedIdDocumentName) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.documentTypesList, (dt) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: dt.id
                }, _toDisplayString(dt.name), 1))
              }), 128))
            ], 512), [
              [_vModelSelect, $setup.selectedIdDocumentName]
            ]),
            (!$setup.selectedIdDocumentName)
              ? (_openBlock(), _createElementBlock("span", _hoisted_91, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_92, [
            _hoisted_93,
            _withDirectives(_createElementVNode("input", {
              class: "col-8",
              type: "input",
              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (($setup.securityOfficerObject.IdDocumentInfo.number) = $event))
            }, null, 512), [
              [_vModelText, $setup.securityOfficerObject.IdDocumentInfo.number]
            ]),
            (!$setup.securityOfficerObject.IdDocumentInfo.number)
              ? (_openBlock(), _createElementBlock("span", _hoisted_94, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_95, [
            _hoisted_96,
            _createElementVNode("span", _hoisted_97, [
              _createElementVNode("span", _hoisted_98, "(" + _toDisplayString($setup.dateToYYYYMMDD($setup.securityOfficerObject.IdDocumentInfo.issueDate)) + ") ", 1),
              _withDirectives(_createElementVNode("input", {
                class: "col-6",
                type: "date",
                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (($setup.securityOfficerObject.IdDocumentInfo.issueDate) = $event))
              }, null, 512), [
                [_vModelText, $setup.securityOfficerObject.IdDocumentInfo.issueDate]
              ])
            ]),
            (!$setup.securityOfficerObject.IdDocumentInfo.issueDate)
              ? (_openBlock(), _createElementBlock("span", _hoisted_99, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_100, [
            _hoisted_101,
            _createElementVNode("span", _hoisted_102, [
              _createElementVNode("span", _hoisted_103, "(" + _toDisplayString($setup.dateToYYYYMMDD($setup.securityOfficerObject.IdDocumentInfo.expiryDate)) + ") ", 1),
              _withDirectives(_createElementVNode("input", {
                class: "col-6",
                type: "date",
                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (($setup.securityOfficerObject.IdDocumentInfo.expiryDate) = $event))
              }, null, 512), [
                [_vModelText, $setup.securityOfficerObject.IdDocumentInfo.expiryDate]
              ])
            ]),
            (!$setup.securityOfficerObject.IdDocumentInfo.expiryDate)
              ? (_openBlock(), _createElementBlock("span", _hoisted_104, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_105, [
            _hoisted_106,
            _withDirectives(_createElementVNode("select", {
              class: "col-8",
              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (($setup.selectedIdDocumentCountryOfIssue) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.nationalityList, (n) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: n.id
                }, _toDisplayString(n.name), 1))
              }), 128))
            ], 512), [
              [_vModelSelect, $setup.selectedIdDocumentCountryOfIssue]
            ]),
            (!$setup.selectedIdDocumentCountryOfIssue)
              ? (_openBlock(), _createElementBlock("span", _hoisted_107, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["row col-12 text-left", {'border-2': true, 'bg-warning':!$setup.isPrivacyPolicyAgreed}])
          }, [
            _withDirectives(_createElementVNode("input", {
              class: "col-2 text-left",
              type: "checkbox",
              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (($setup.isPrivacyPolicyAgreed) = $event))
            }, null, 512), [
              [_vModelCheckbox, $setup.isPrivacyPolicyAgreed]
            ]),
            _hoisted_108
          ], 2)
        ])
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn-primary",
        onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => ($setup.UpdateOfficer && $setup.UpdateOfficer(...args)))
      }, " Save")
    ])
  ], 64))
}